import React, { useReducer } from 'react';
import AuthReducer from './authReducer';
import AuthContext from './authContext';
import clienteAxios from '../../config/axios';
import tokenAuth from '../../config/tokenAuth';

import {
    REGISTRO_EXITOSO
    ,REGISTRO_ERROR  
    ,OBTENER_USUARIO 
    ,LOGIN_EXITOSO   
    ,LOGIN_ERROR     
    ,CERRAR_SESION   
    ,TOKEN_ERROR
    ,TOKEN_EXITOSO
    ,RECUPERAR_EXITOSO
    ,RECUPERAR_ERROR
} from '../../types';

const AuthState = props => {
    const inicialState = {
        token: localStorage.getItem('token'),
        autenticado: null,
        recuperoContraseña: null,
        usuario: null,
        mensaje: null,
        cargando: true,
        accesos: null
    }

    const [ state, dispatch ] = useReducer(AuthReducer, inicialState);

    // Funciones
    const registrarUsuario = async datos => {
        try {
            const dataKey = {
                APIKey: process.env.REACT_APP_API_KEY
                //esDesarrollo: process.env.REACT_APP_VAR_ESDESARROLLO
            }
            //const respuestaToken = await clienteAxios.post('/Auth?code=MVNADGLToxXVbxlcEARFqyjyUF4NNBQmrNE1mV7916vDbrvoQtdATA==',dataKey);
            const respuestaToken = await clienteAxios.post('/auth',dataKey);

            if(respuestaToken) {
                dispatch({
                    type: TOKEN_EXITOSO,
                    payload: respuestaToken.data.token
                })

                usuarioAPIAutenticado(0);

                const { tipoContacto, nombre, email, password, paisId, activo } = datos;
                const d = {
                    encabezado: { tipoContacto, nombre, email, password, paisId, activo }
                }
                const respuestaRegistro = await clienteAxios.post('/loginContacto/registrarNuevo', d);
                const respuesta = respuestaRegistro.data;

                if(respuesta.status !== 200){
                    const alerta = {
                        msg: respuesta.mensaje,
                        categoria: 'alert-danger'
                    }

                    dispatch({
                        type: REGISTRO_ERROR,
                        payload: alerta
                    })
                } else {
                    dispatch({
                        type: REGISTRO_EXITOSO,
                        payload: respuesta
                    })

                    usuarioAPIAutenticado(1);
                }
            }

        } catch (error) {
            console.dir(error, {depth:null});
            const alerta = {
                msg: 'Ocurrió un error',
                categoria: 'alert-danger'
            }

            dispatch({
                type: REGISTRO_ERROR,
                payload: alerta
            })
        }
    }
    const recuperarPassword = async datos => {
        try {
            const dataKey = {
                APIKey: process.env.REACT_APP_API_KEY
            }
            const respuestaToken = await clienteAxios.post('/auth',dataKey);

            if(respuestaToken) {
                dispatch({
                    type: TOKEN_EXITOSO,
                    payload: respuestaToken.data.token
                })
                const { tipoContacto, nombre, email, password, paisId, activo } = datos;
                const d = {
                    encabezado: { tipoContacto, nombre, email, password, paisId, activo }
                }
                usuarioAPIAutenticado(0);
                const respuestaRegistro = await clienteAxios.post('/loginContacto/recuperarPassword', d);
                const respuesta = respuestaRegistro.data;

                if(respuestaRegistro.status !== 200){
                    const alerta = {
                        msg: respuesta.mensaje,
                        categoria: 'alert-danger'
                    }
                    dispatch({
                        type: RECUPERAR_ERROR,
                        payload: alerta
                    })
                } else {
                    dispatch({
                        type: RECUPERAR_EXITOSO,
                        payload: respuesta
                    })
                }
            }

        } catch (error) {
            console.dir(error, {depth:null});
            const alerta = {
                msg: 'Ocurrió un error',
                categoria: 'alert-danger'
            }

            dispatch({
                type: RECUPERAR_ERROR,
                payload: alerta
            })
        }
    }
    // Retorna el usuario autenticado
    const usuarioAPIAutenticado = async (proceso) => {
        const token = localStorage.getItem('token');
        if(token) {
            // TODO: Función para enviar el token por headers
            tokenAuth(token);
        }

        if(proceso === 1){
            const usuario = JSON.parse(localStorage.getItem('usuario'));
            if(usuario){
                dispatch({
                    type: OBTENER_USUARIO,
                    payload: usuario
                })
            } else {
                dispatch({
                    type: LOGIN_ERROR
                })
            }
        }
    }

    const iniciarSesion = async datos => {
        try {
            const dataKey = {
                APIKey: process.env.REACT_APP_API_KEY
                //esDesarrollo: process.env.REACT_APP_VAR_ESDESARROLLO
            }
            //const respuestaToken = await clienteAxios.post('/Auth?code=MVNADGLToxXVbxlcEARFqyjyUF4NNBQmrNE1mV7916vDbrvoQtdATA==',dataKey);
            const respuestaToken = await clienteAxios.post('/auth',dataKey);

            if(respuestaToken) {
                dispatch({
                    type: TOKEN_EXITOSO,
                    payload: respuestaToken.data.token
                })

                usuarioAPIAutenticado(0);

                const { email, password } = datos;
                const d = {
                    usuario: email,
                    password: password
                }
                const respuestaRegistro = await clienteAxios.post('/loginContacto', d);
                const respuesta = respuestaRegistro;
                
                if(respuesta.status !== 200){
                    const alerta = {
                        msg: respuesta.data.mensaje,
                        categoria: 'alert-danger'
                    }

                    dispatch({
                        type: LOGIN_ERROR,
                        payload: alerta
                    })
                } else {
                    dispatch({
                        type: LOGIN_EXITOSO,
                        payload: respuesta.data
                    })
                }
            } else {
                const alerta = {
                    msg: 'Error al iniciar sesión. No se pudo conectar al servidor.',
                    categoria: 'alert-danger'
                }
                dispatch({
                    type: TOKEN_ERROR,
                    payload: alerta
                })
            }

        } catch (error) {
            const alerta = {
                msg: `Error de autenticación. ${error.response.data.mensaje}`,
                categoria: 'alert-danger'
            }

            dispatch({
                type: LOGIN_ERROR,
                payload: alerta
            })
        }
    }

    const cerrarSesion = () => {
        dispatch({
            type:CERRAR_SESION
        })
    }


    return ( 
        <AuthContext.Provider
            value={{
                token: state.token,
                autenticado: state.autenticado,
                recuperoContraseña: state.recuperoContraseña,
                usuario: state.usuario,
                mensaje: state.mensaje,
                cargando: state.cargando,
                accesos: state.accesos,
                registrarUsuario,
                recuperarPassword,
                usuarioAPIAutenticado,
                iniciarSesion,
                cerrarSesion
            }}
        >
            {props.children}
        </AuthContext.Provider>
     )
}
 
export default AuthState;